/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// require("prismjs/themes/prism-okaidia.css");
require("prismjs/themes/prism-solarizedlight.css");
require("./gatsby-browser.code.theme.css");
